<template>
  <div class="ui-data-field">
    <span class="ui-data-field__label">{{ label }}</span>

    <span class="ui-data-field__value"><slot /></span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>
